import React from 'react';
import ReactDOM from 'react-dom';
import window from 'window-or-global';
import PropTypes from 'prop-types';

import { getSessionData, SessionDataContext } from '@confluence/session-data';
import { ChoreographerAssetsContextProvider } from '@confluence/choreographer-services';
import ComponentWrapper from '../ComponentWrapper';
import configureStore from '../../../stores/configureStore';
import { subscribe } from '../../../subscriptions';
import { createRoot } from 'react-dom/client';

const store = configureStore({ isServerRenderedPage: true });
subscribe(store);

const context = {
	insertCss: (styles) => styles._insertCss(),
};

/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */
const renderComponentIntoDOM = (children, container, renderAsRoot = false) => {
	if (typeof container === 'string') {
		container = window.document.getElementById(container);
	}
	const urlParams = new URLSearchParams(window?.location?.search);
	const legacyModeParam = urlParams.has('LEGACY_MODE', '1');

	const Component = ({ sessionData }) => (
		<SessionDataContext.Provider value={sessionData}>
			<ChoreographerAssetsContextProvider>
				<ComponentWrapper store={store} context={context} renderAsRoot={renderAsRoot}>
					{children}
				</ComponentWrapper>
			</ChoreographerAssetsContextProvider>
		</SessionDataContext.Provider>
	);

	Component.propTypes = {
		sessionData: PropTypes.object.isRequired,
	};

	getSessionData().then((sessionData) => {
		if (!legacyModeParam) {
			const concurrentComponentWrapper = createRoot(container);
			concurrentComponentWrapper.render(<Component sessionData={sessionData} />);
		} else {
			// eslint-disable-next-line react/no-deprecated
			ReactDOM.render(<Component sessionData={sessionData} />, container);
		}
	});
};

export default renderComponentIntoDOM;
